import {
  Box,
  Button,
  TextField,
  Typography,
  Card,
  InputAdornment,
  Avatar,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Logo from "../../../imagens/logo-azul";
import Fundo from "../../../imagens/fundo-qrpedir-min.png";
import AuthService from "../../../AuthService";
import { hotjar } from "react-hotjar";
import { useParams, useNavigate } from "react-router-dom";
import md5 from "js-md5";

const ConfigNewUser = () => {
  const [user, setUser] = useState(null);
  const [unhashedPassword, setUnhashedPassword] = useState("");
  const [uuidIdentificador, setUuidIdentificador] = useState("");
  const [open, setOpen] = useState(false);
  const [usuarioAdmin, setUsuarioAdmin] = useState(null);
  const [errosConfig, setErrosConfig] = useState({
    unhashedPassword: null,
    uuidIndentificador: null,
  });

  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    handleVerificaUsuarioAdm();
  }, []);

  useEffect(() => {
    const service = new AuthService();
    service.logout();
    service
      .get(`/usuario/getToken?token=${token}`)
      .then((resp) => setUser(resp))
      .catch((err) => console.error(err));
  }, [token]);

  const handleVerificaUsuarioAdm = () => {
    let profile = localStorage.getItem("_profile");
    if (profile) {
      setUsuarioAdmin(JSON.parse(profile));
    }
  };

  const handleChange = (event, type) => {
    if (type === "senha") {
      setUnhashedPassword(event.target.value);
    } else if (type === "identificador") {
      let valor = event.target.value.replace(/[^\w\s]/gi, "");
      if (valor.match(/ /)) {
        valor = valor?.replace(/ /, "-");
      }
      setUuidIdentificador(valor);
    }
  };

  const uploadFileServer = (file) => {
    const cloudName = "parseint";
    const unsignedUploadPreset = "upload-qrpedir";

    const url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;
    const xhr = new XMLHttpRequest();
    const fd = new FormData();

    xhr.open("POST", url, true);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

    xhr.upload.addEventListener("progress", function (e) {
      Math.round((e.loaded * 100.0) / e.total);
    });

    const onCompleteUpload = (response) => {
      const updatedUser = { ...user };
      updatedUser.empresa.urlLogo = response.secure_url;
      setUser(updatedUser);
    };

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        onCompleteUpload(response);
      }
    };

    fd.append("upload_preset", unsignedUploadPreset);
    fd.append("tags", "browser_upload");
    fd.append("file", file);
    xhr.send(fd);
  };

  const validaIdentificador = (erros, error) => {
    const userIsAdm = usuarioAdmin?.admin ? true : false;
    const service = new AuthService();

    service
      .get(`/identificador/validaUrlDelivery/${uuidIdentificador}`)
      .then((resp) => {
        if (resp.value === "IDENTIFICADOR_EXISTENTE") {
          erros.uuidIndentificador = "Endereço digital ja está sendo utilizado";
          error = true;
          setErrosConfig(erros);
          if (error) return;
        } else {
          setErrosConfig(erros);
          if (error) return;

          const updatedUser = { ...user, password: md5(unhashedPassword) };

          service
            .post(`/usuario/changePassword`, updatedUser)
            .then((resp) => {
              const token = resp.token;
              service
                .post(
                  `/identificador/changeUuidForNewUser/${updatedUser.empresa.id}/${uuidIdentificador}`
                )
                .catch(console.error);

              const hoje = new Date();
              if (!userIsAdm) {
                updatedUser.empresa.dataBloqueio = new Date(
                  hoje.setDate(hoje.getDate() + 15)
                );
              }

              updatedUser.empresa.configuracaoAbertura = "SEMPRE_ABERTO";
              updatedUser.empresa.ativo = true;

              const options = {
                method: "POST",
                body: JSON.stringify(updatedUser.empresa),
                headers: {
                  Authorization: "Bearer " + token,
                  Accept: "application/json",
                  "Content-Type": "application/json; charset=utf-8",
                },
              };

              service
                .myFetch(`/empresa`, options)
                .then(() => setOpen(true))
                .catch(console.error);

              setUser(resp);
            })
            .catch(console.error);
        }
      });
  };

  const handleSave = () => {
    let error = false;
    const erros = {
      unhashedPassword: null,
      uuidIndentificador: null,
    };

    if (!unhashedPassword) {
      erros.unhashedPassword = "É necessario escolher uma senha";
      error = true;
    }

    if (!uuidIdentificador) {
      erros.uuidIndentificador =
        "É necessario escolher um endereco digital para seu cardapio";
      error = true;
    }

    validaIdentificador(erros, error);
  };

  const logar = () => {
    const service = new AuthService();
    service
      .login(user.username, user.password)
      .then(() => {
        hotjar.initialize(2227724, 6);
        navigate("/Cardapio", { replace: true });
      })
      .catch(console.error);
  };

  const empresa = user ? user.empresa : null;
  const styles = {
    fundo: {
      height: "100vh",
      background: `url(${Fundo}) repeat`,
    },
  };

  return (
    <Box
      style={styles.fundo}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        style={{ height: "800px" }}
      >
        <Box display="flex" justifyContent="center" p={4} mt={6}>
          <Logo
            style={{ width: "15vw", minWidth: "200px", height: "auto" }}
            alt="logo"
          />
        </Box>
        <Box flexDirection="row" display="flex" justifyContent="center">
          <Box display="block">
            <input
              type="file"
              id="fileElem"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => uploadFileServer(e.target.files[0])}
            />
          </Box>
        </Box>
        <Card
          style={{
            padding: "2vw",
            width: "30vw",
            minWidth: "300px",
            maxWidth: "450px",
            maxHeight: "500px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
            style={{ height: "100%" }}
          >
            {user ? (
              <>
                <Typography
                  align="center"
                  variant="h5"
                  style={{ margin: "10px 0" }}
                >
                  Cadastro de empresa
                </Typography>
                <TextField
                  label="Nova Senha"
                  type="password"
                  error={errosConfig.unhashedPassword != null}
                  helperText={errosConfig.unhashedPassword}
                  style={{ margin: "10px" }}
                  name="unhashedPassword"
                  value={unhashedPassword || ""}
                  onChange={(e) => handleChange(e, "senha")}
                  variant="outlined"
                  fullWidth
                />
                {empresa && (
                  <>
                    <TextField
                      variant="outlined"
                      label="Link do cardápio"
                      error={errosConfig.uuidIndentificador != null}
                      helperText={errosConfig.uuidIndentificador}
                      placeholder="EX.: Nome-Empresa"
                      name="uuidIdentificador"
                      value={uuidIdentificador || ""}
                      onChange={(e) => handleChange(e, "identificador")}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            .qrpedir.com
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Avatar
                        variant="circular"
                        alt="Logo da empresa"
                        src={empresa.urlLogo}
                        style={{
                          width: "120px",
                          height: "120px",
                          marginTop: "20px",
                        }}
                      />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Link
                        href="#"
                        onClick={() =>
                          document.getElementById("fileElem").click()
                        }
                      >
                        Alterar logo
                      </Link>
                    </Box>
                    {empresa.urlLogo && (
                      <Box
                        display="flex"
                        flexDirection="row"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <Link
                          href="#"
                          onClick={() => {
                            setUser({
                              ...user,
                              empresa: { ...empresa, urlLogo: null },
                            });
                          }}
                        >
                          Remover logo
                        </Link>
                      </Box>
                    )}
                  </>
                )}
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  style={{ marginTop: "20px", width: "100%" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                  >
                    Finalizar
                  </Button>
                </Box>
              </>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                flexDirection="column"
              >
                <Typography style={{ fontSize: "150%" }} align="center">
                  Ops, parece que o token foi expirado, ou é invalido.
                </Typography>
                <Button
                  onClick={() =>
                    window.open("https://qrpedir.com/suporte", "_blank")
                  }
                  style={{ marginTop: "40px" }}
                >
                  Entrar em contato com nossa equipe
                </Button>
              </Box>
            )}
            <Dialog open={open}>
              <DialogTitle>
                <Typography>Seu cadastro foi realizado com sucesso.</Typography>
              </DialogTitle>
              <DialogContent>
                <Box display="flex" justifyContent="center">
                  <Button variant="contained" color="primary" onClick={logar}>
                    Clique aqui para continuar
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default ConfigNewUser;
